// extracted by mini-css-extract-plugin
module.exports = {"checkbox-wrapper":"src-components-Checkbox-styles__checkbox-wrapper--12fbt"};